import React, { Component } from "react";
// import DKLine from "../DKLine";
// import DKIcon from "../DKIcon";
// import { DKIcons } from "../Constants/Icons";
// import DKSpaceV from "../DKSpaceV";
// import "./DKSidebar.css";
import { DkSideBarItem } from "./DKSidebarItem";
import TenantController from "./DKTenantController";
import { DKLine, DKIcon, DKIcons, DKSpaceV, DKLabel } from "deskera-ui-library";
import DeskeraLogo from "../../../assets/ic_deskera.png";
import RouteManager from "../../../managers/RouteManager";
import { PAGE_ROUTES, PERMISSION_APP_NAME } from "../../../constants/Constant";
import ic_reports_filled from "../../../assets/ic-report-builder-filled.svg";
import { isEmpty } from "../../../utilities/Common";
import AuthManager from "../../../managers/AuthManager";
import { connect } from "react-redux";

/*
 PROPS:
  - className: string,
  - menuItemList: MenuItem[],
  - collapsedWidth: number,
  - expandedWidth: number,
  - isMenuExpanded: boolean,
  - onExpandCollapse: () => void,
  - allowTenantSelection: boolean,
  - tenantList: TenantDetail[],
  - tenantPickerTitle?: string,
  - tenantPickerButtonTitle?: string,
  - selectedTenantDetails: TenantDetail,
  - onTenantSelect: (data) => void,
  - onAddNewTenantTapped: (data) => void


  Types:
  - MenuItem { name: string, icon: string, className?: string, route?: string, subItems?: MenuItem[], onClick?: () => void }
  - TenantDetail { tenantName: string, tenantId: number, ... }
*/

class DKSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenuItemId: "0",
      expandedItemsId: ["0"],
    };

    /* constants */
    this.collapsedWidth = 0;
    this.expandedWidth = 230;
  }

  componentDidMount() {
    let activeTabId = this.getActiveTabId(this.props.menuItemList);
    let expandedItemList = this.getExpandedTabList(this.props.menuItemList);

    if (activeTabId) {
      const tabIndexes = activeTabId.split("_");
      /* getting tab id's for all levels */
      tabIndexes.reduce((parentTabId, currentTabIndex) => {
        const currentTabId = parentTabId
          ? `${parentTabId}_${currentTabIndex}`
          : `${currentTabIndex}`;

        if (!expandedItemList.includes(currentTabId)) {
          expandedItemList.push(currentTabId);
        }

        return currentTabId;
      }, "");
      this.setActiveMenuItemId(activeTabId);
    }

    if (expandedItemList.length) {
      this.setExpandedItemsId(expandedItemList);
    }
  }
  componentWillReceiveProps(nextProps) {
    let newStateToUpdate = {}
    if (nextProps.permissions !== this.props.permissions && this.props.aiReport) {
        newStateToUpdate = {
            ...newStateToUpdate,
            hasReportPermission:this.isUserPermitted(nextProps.permissions)
        };
    }
    this.setState({
        ...newStateToUpdate
    })
  }
  isUserPermitted = (permissions) => {
      let flag = true;
      try {
          if (isEmpty(permissions)) return flag;
          if(!this.props.aiReport) {
            return flag
          }
          const permittedApps = permissions.apps || [];
          const isReportBuilderPermitted = permittedApps.some(
              (app) => app.appName === PERMISSION_APP_NAME.REPORT_BUILDER
          );
          const isUserOwner = this.props.tenantDetails?.userId === AuthManager.token?.["iamUserId"];

          if (isReportBuilderPermitted) {
            return true;
          } else {
            flag = false;
          }
          if(!AuthManager.statusOfPermissionAlertIsOpen ) {
            AuthManager.getProductPermissionAlert(isUserOwner);
          }
      } catch(err) {}

      return flag;
  }
  setActiveMenuItemId(id) {
    this.setState({ activeMenuItemId: id });
  }
  setExpandedItemsId(ids) {
    this.setState({ expandedItemsId: ids });
  }

  getActiveTabId(menuItems) {
    let activeTabId = null;
    menuItems?.forEach((menuItem, tabIndex) => {
      if (menuItem.route === window.location.pathname) {
        activeTabId = `${tabIndex}`;
        return;
      }

      const submenuActiveId = this.getActiveTabId(menuItem.subItems);
      if (submenuActiveId) {
        activeTabId = `${tabIndex}_${submenuActiveId}`;
      }
    });
    return activeTabId;
  }

  getExpandedTabList(menuItems) {
    const expandedItemIdList = [];

    menuItems?.forEach((menuItem, tabIndex) => {
      if (menuItem.expandByDefault) {
        expandedItemIdList.push(`${tabIndex}`);
      }

      const submenuExpandedItemIds = this.getExpandedTabList(menuItem.subItems);
      expandedItemIdList.push(
        ...submenuExpandedItemIds.map(
          (expandedItemId) => `${tabIndex}_${expandedItemId}`
        )
      );
    });

    return expandedItemIdList;
  }

  render() {
    return (
      <div
        id="dk-sidebar"
        className={`dk-sidebar screen-height bg-app pt-m pb-ls column justify-content-between z-index-4 flex-shrink-0 ${this.props?.className}`}
        style={{
          width: this.props.isMenuExpanded
            ? this.expandedWidth
            : this.collapsedWidth,
        }}
      >
        <div
          className={`dk-sidebar-toggle p-s ${this.props.isMenuExpanded ? "collapsible-button" : ""
            } cursor-hand z-index-4`}
          style={{
            position: "fixed",
            left: this.props.isMenuExpanded ? this.expandedWidth - 20 : -20,
            top: 45,
          }}
          onClick={() => {
            this.props.onExpandCollapse?.();
          }}
        >
          <div className="shadow-m border-radius-l bg-white d-flex text-white align-items-center justify-content-center">
            <DKIcon
              src={DKIcons.ic_arrow_left}
              className={`p-s ic-xs dk-sidebar-arrow-icon`}
            />
          </div>
        </div>
        <div
          className="column parent-width position-relative parent-height bottom-0"
          style={{
            overflowX: this.props.isMenuExpanded ? "visible" : "hidden",
          }}
        >
          <div className="row width-auto mt-r p-h-m">
            <div
              className="circle p-xs row align-items-center justify-content-center"
              style={{
                width: 48,
                height: 48,
                backgroundColor: "rgba(0,0,0,0.2)",
              }}
            >
              <DKIcon src={ic_reports_filled} className="ic-m" />
            </div>
            {/* <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path 
                fill-rule="evenodd" 
                clip-rule="evenodd" 
                d="M23.1518 16.4625L23.2389 16.4648L23.312 16.4429C23.6371 16.3386 24.9375 15.8273 24.9375 14.3413C24.9375 13.408 25.3083 12.5129 25.9683 11.8529C26.6279 11.1929 27.523 10.8222 28.4563 10.8222C33.0029 10.8222 39.6235 10.8222 44.566 10.8222C45.898 10.8222 47.176 11.3514 48.118 12.2935C49.0601 13.2355 49.5893 14.5135 49.5893 15.8459V36.2778C49.5893 38.2213 48.0137 39.797 46.0702 39.797H44.8621C43.9246 39.797 43.1635 40.558 43.1635 41.4952C43.1635 42.4327 43.9246 43.1938 44.8621 43.1938C44.8621 43.1938 45.3561 43.1938 46.0702 43.1938C49.8897 43.1938 52.9859 40.0973 52.9859 36.2778C52.9859 30.7239 52.9859 21.916 52.9859 15.8459C52.9859 13.6125 52.0989 11.4708 50.5197 9.89184C48.9408 8.3126 46.799 7.42564 44.566 7.42564C39.6235 7.42564 33.0029 7.42564 28.4563 7.42564C26.6224 7.42564 24.8631 8.15412 23.5663 9.4513C22.2695 10.7481 21.5406 12.5071 21.5406 14.3413C21.5406 14.5803 21.5406 14.7333 21.5406 14.7616V14.7636V14.7662C21.5406 14.8027 21.542 14.8386 21.5446 14.8741C21.57 15.3756 21.7712 15.7197 22.0272 15.9551C22.3161 16.2502 22.712 16.44 23.1518 16.4625Z" 
                fill="white"
              />
              <path 
                fill-rule="evenodd" 
                clip-rule="evenodd" 
                d="M19.5362 33.9382C19.5118 33.5755 19.2483 33.2739 18.8922 33.2012C17.5891 32.9514 16.2502 32.9514 14.9475 33.2041C14.5931 33.2768 14.3306 33.5772 14.3061 33.9382C14.2712 34.4093 14.2272 35.0589 14.1972 35.5024C14.1766 35.803 13.9908 36.0672 13.7146 36.1878C13.2173 36.4076 12.7451 36.6802 12.3049 36.9995C12.0629 37.1778 11.7421 37.2065 11.4724 37.0741C11.072 36.8804 10.4876 36.5938 10.0634 36.3858C9.73729 36.2257 9.34436 36.3033 9.10338 36.5749C8.23566 37.5786 7.56621 38.7381 7.13382 39.9926C7.01936 40.336 7.14816 40.7136 7.44882 40.9151C7.83914 41.1809 8.37947 41.5438 8.74893 41.7916C8.99903 41.9599 9.13469 42.253 9.1011 42.5524C9.04306 43.0927 9.04306 43.6379 9.09914 44.1789C9.13273 44.4776 8.99708 44.7698 8.74762 44.9374C8.37947 45.1872 7.83914 45.5501 7.44686 45.8133C7.14523 46.0158 7.01577 46.3947 7.13056 46.7393C7.56621 47.9925 8.23566 49.1524 9.10566 50.1538C9.34599 50.4245 9.73729 50.5017 10.0621 50.3423C10.4876 50.1372 11.072 49.8505 11.4714 49.6546C11.7418 49.5222 12.0636 49.5512 12.3062 49.7299C12.7451 50.0508 13.2173 50.323 13.7139 50.5448C13.9891 50.6651 14.1747 50.9289 14.1949 51.2286C14.2272 51.6721 14.2712 52.3216 14.3032 52.7928C14.3276 53.1554 14.5911 53.4571 14.9469 53.5298C16.2502 53.7796 17.5891 53.7796 18.8915 53.5268C19.246 53.4541 19.5085 53.1538 19.5329 52.7928C19.5682 52.3216 19.6122 51.6721 19.6422 51.2283C19.6627 50.9279 19.8486 50.6638 20.1248 50.5431C20.6218 50.323 21.0939 50.0508 21.5341 49.7315C21.7761 49.5531 22.0973 49.5245 22.367 49.6568C22.7671 49.8505 23.3518 50.1372 23.7757 50.3452C24.1021 50.505 24.4947 50.4277 24.736 50.1561C25.6037 49.1524 26.2732 47.9925 26.7056 46.7384C26.82 46.395 26.6909 46.0174 26.3906 45.8159C26.0002 45.5501 25.4596 45.1872 25.0904 44.9393C24.8403 44.7711 24.7047 44.4779 24.7383 44.1786C24.7963 43.6379 24.7963 43.0927 24.7402 42.5521C24.7066 42.2534 24.8423 41.9612 25.0918 41.7936C25.4596 41.5438 26.0002 41.1809 26.3922 40.9177C26.6938 40.7152 26.8233 40.3363 26.7085 39.9916C26.2732 38.7381 25.6037 37.5786 24.7334 36.5772C24.4934 36.3062 24.1021 36.2292 23.7773 36.3887C23.3518 36.5938 22.7671 36.8804 22.3679 37.0761C22.0973 37.2088 21.7754 37.1798 21.5332 37.0011C21.0939 36.6802 20.6218 36.4076 20.1254 36.1862C19.8502 36.0655 19.6647 35.8021 19.6445 35.5024C19.6122 35.0589 19.5682 34.4093 19.5362 33.9382ZM16.9197 40.7778C18.3479 40.7778 19.5072 41.9374 19.5072 43.3653C19.5072 44.7936 18.3479 45.9532 16.9197 45.9532C15.4914 45.9532 14.3319 44.7936 14.3319 43.3653C14.3319 41.9374 15.4914 40.7778 16.9197 40.7778Z" 
                fill="white"
              />
              <path 
                fill-rule="evenodd" 
                clip-rule="evenodd" 
                d="M14.9387 31.5711V21.2393C14.9387 17.5154 17.9619 14.4919 21.6858 14.4919H39.6369C43.3608 14.4919 46.3839 17.5154 46.3839 21.2393V43.513C46.3839 47.235 43.364 50.2568 39.6427 50.2601L26.793 50.3201C27.4787 49.3748 28.0226 48.3352 28.4058 47.2327C28.4071 47.2294 28.4081 47.2262 28.4094 47.2229C28.6722 46.4403 28.3768 45.5791 27.6894 45.1226C27.2945 44.8588 26.7457 44.4962 26.3436 44.2308C26.3997 43.6542 26.4 43.0741 26.3452 42.4973C26.7444 42.2315 27.2919 41.8702 27.6868 41.6097C28.3781 41.1535 28.6761 40.2887 28.4123 39.5031C28.411 39.4992 28.4097 39.495 28.4081 39.4911C27.8912 38.0142 27.0881 36.6496 26.0404 35.4753C26.0381 35.4727 26.0361 35.4704 26.0338 35.4678C25.4906 34.8707 24.6196 34.7018 23.8924 35.0524C23.4607 35.2575 22.8476 35.5529 22.4055 35.7662C21.9189 35.4235 21.3998 35.1284 20.8559 34.8835C20.8217 34.411 20.777 33.7673 20.745 33.3023C20.6889 32.4835 20.0938 31.8029 19.29 31.6379C19.2861 31.6373 19.2822 31.6363 19.2783 31.6356C17.8461 31.3591 16.3761 31.3369 14.9387 31.5711ZM30.644 23.6719V40.4749C30.644 41.4124 31.4051 42.1735 32.3423 42.1735C33.2798 42.1735 34.0409 41.4124 34.0409 40.4749V23.6719C34.0409 22.7348 33.2798 21.9737 32.3423 21.9737C31.4051 21.9737 30.644 22.7348 30.644 23.6719ZM36.6323 21.5237V40.4749C36.6323 41.4124 37.3934 42.1735 38.3306 42.1735C39.2681 42.1735 40.0292 41.4124 40.0292 40.4749V21.5237C40.0292 20.5865 39.2681 19.8254 38.3306 19.8254C37.3934 19.8254 36.6323 20.5865 36.6323 21.5237ZM24.6558 25.695V31.1194C24.6558 32.0566 25.4169 32.8177 26.354 32.8177C27.2915 32.8177 28.0526 32.0566 28.0526 31.1194V25.695C28.0526 24.7575 27.2915 23.9967 26.354 23.9967C25.4169 23.9967 24.6558 24.7575 24.6558 25.695Z" 
                fill="white"
              />
            </svg> */}
            <div className="column ml-r">
              <DKIcon src={DeskeraLogo} style={{ height: 23 }} className="" />
              <DKLabel
                text="Report Builder"
                className="text-white mt-s opacity-6 fs-m"
              />
            </div>
          </div>
          <TenantController
            tenantList={this.props.tenantList}
            isMenuExpanded={this.props.isMenuExpanded}
            selectedTenantDetails={this.props.selectedTenantDetails}
            tenantPickerTitle={this.props.tenantPickerTitle}
            tenantPickerButtonTitle={this.props.tenantPickerButtonTitle}
            onTenantSelect={this.props.onTenantSelect}
            onAddNewTenantTapped={this.props.onAddNewTenantTapped}
            onSaveNewTenantTapped={this.props.onSaveNewTenantTapped}
            allowTenantSelection={this.props.allowTenantSelection}
            allowAddTenant={
              this.props.allowAddTenant === null ||
                this.props.allowAddTenant === undefined
                ? true
                : this.props.allowAddTenant
            }
          />
          <DKLine
            className="mt-r"
            style={{
              opacity: 0.1,
            }}
          />
          <DKSpaceV value={15} />
          <div
            className={`column p-h-m border-box parent-width hide-scroll-bar mb-l`}
            style={{
              overflowY: "auto",
              overflowX: this.props.isMenuExpanded ? "hidden" : "visible",
              flexGrow: 1,
            }}
          >
            {this.props.menuItemList.map((item, index) =>
              this.props.itemRenderer ? (
                this.props.itemRenderer(item)
              ) : (
                <DkSideBarItem
                  {...item}
                  key={`${index}`}
                  level={0}
                  tabId={`${index}`}
                  activeMenuItemId={this.state.activeMenuItemId}
                  expandedItemsId={this.state.expandedItemsId}
                  isSidebarCollapsed={!this.props.isMenuExpanded}
                  onLinkClick={(tabId) => {
                    this.setActiveMenuItemId(tabId);
                  }}
                  onToggleSubMenu={(tabId) => {
                    const newCurrentMenuIndex = [];
                    let isExisting = false;
                    this.state.expandedItemsId.forEach((expandedTabId) => {
                      if (expandedTabId === tabId) {
                        isExisting = true;
                      } else {
                        newCurrentMenuIndex.push(expandedTabId);
                      }
                    });

                    if (!isExisting) {
                      newCurrentMenuIndex.push(tabId);
                    }

                    this.setExpandedItemsId(newCurrentMenuIndex);
                  }}
                />
              )
            )}
          </div>
          {this.state.hasReportPermission && <div
            className="row border-radius-l bg-whites text-white p-r shadow-s-2 cursor-hand justify-content-center"
            style={{
              border: "1px solid rgba(255,255,255,0.6)",
              margin: '10px auto',
              width: '90%',
              backgroundColor: "rgba(0,0,0,0.2)",
            }}
            onClick={() => RouteManager.navigateToPage(PAGE_ROUTES.CREATE_REPORT)}
          >
            <div className="column">
              <DKLabel
                text="+ New Report"
                className="fw-m fs-m"
              />
            </div>
          </div>}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  tenantDetails: state.tenant.tenantInfo,
  permissions: state.tenant.permissions,
});
const mapDispatchToProps = {
  // fetchReportTablesByAppName,
  // getPeopleEmployeeFields,
  // fetchMultiTenantAccess
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(DKSidebar);

